import type { VybeTraderClient } from "../connection/client/VybeTraderClient";
import { useNewsStore } from "./stores/useNewsStore";

let sessionSyncInFlight: Promise<void> | null = null;

/**
 * Hash-based news sync: loads the client-side cache, then asks the server only for new/missing
 * sequences (buildSyncRequest). Guarded so the connect and account-connect paths that both trigger
 * it don't fire two concurrent full syncs.
 */
export async function prepareAndSyncNews(client: VybeTraderClient): Promise<void> {
  if (sessionSyncInFlight) return sessionSyncInFlight;
  sessionSyncInFlight = runSyncNews(client).finally(() => {
    sessionSyncInFlight = null;
  });
  return sessionSyncInFlight;
}

async function runSyncNews(client: VybeTraderClient): Promise<void> {
  const store = useNewsStore.getState();
  store.loadFromStorage();
  const request = store.buildSyncRequest();
  await client.syncNews(request);
}
